import io from "socket.io-client";

let socket = null;

export const initializeSocket = (userId) => {
  if (socket?.connected) {
    return socket;
  }
  socket = io(process.env.REACT_APP_SOCKET_URL, {
    path: "/socket.io/",
    withCredentials: true,
    auth: { userId },
    reconnection: true,
    reconnectionAttempts: 10, // Cố gắng kết nối lại 10 lần
    transports: ["websocket"],
    pingInterval: 25000, // Ping mỗi 25s
    pingTimeout: 5000, // Timeout sau 5s nếu không thấy phản hồi
  });
  return socket;
};
